<div class="quiz-progress-overlay">
  <div class="quiz-progress-card">
    <p class="quiz-progress-text">
      <ng-container *ngIf="progress < 40">Analyzing your quiz topic and checking limit...</ng-container>
	 <ng-container *ngIf="progress >=40 && progress < 60">Crafting intelligent questions...</ng-container> 
        <ng-container *ngIf="progress >= 60 && progress < 99">Almost there! Fine-tuning your quiz content...</ng-container>
		<ng-container *ngIf="progress === 100">
			<span *ngIf="isTopic">Topic recommendation generated successfully!</span>
			<span *ngIf="isQuestion">AI questions generated successfully!</span>
			<mat-icon class="success-bg">verified</mat-icon>
		</ng-container>
    </p>
    <div class="progress-bar-container">
      <div class="progress-bar" [style.width.%]="progress"></div>
    </div>
    <p class="progress-percent">{{ progress }}%</p>
  </div>
</div>
